export interface ITeam {
  uuid?: string;
  bookingId?: number;
  name: string;
  roomPlayers: number;
  startDateTime: string;
  endDateTime: string;
  nfcTag: string;
  paired: boolean;
  ticketUuids: string[]; // used for scanning tickets
  teamLevel: number;
}

export interface ITeamSetting {
  categoryId: number;
  maxParticipants: number;
  countedPsp: number[];
}

export enum BookingTeamsStatus {
  NotStarted = 0,
  Completed = 1,
  InProgress = 2,
}

export enum TeamLevel {
  EASY = 1,
  MEDIUM = 2,
  HARD = 3,
}
